import { h } from 'preact'
import { Post } from './index.sync'
import UserAvatar from '../User/UserAvatar'
import TopicReplyCount from '../../control-components/ui-components/TopicReplyCount'
import TopicViewsCount from '../../control-components/ui-components/TopicViewsCount'
import ClampLines from 'react-clamp-lines'
import Icon from '../assets/'
import htmlParser from '../utils/htmlParser'
import LazyLoader from '../lazy-loading/LazyLoader'

const TOPIC_TYPE_IDEA = 2

interface IdeationStatus {
  name: string
  bgColor: string
  color: string
}

interface Props {
  title: string
  url: string
  featuredImage: string
  label: string
  replyCount: number
  views: number
  fullWidth: boolean
  post: Post
  customClass: string
  type: number
  likes: number
  addLikeHandler: (id: number) => void
  index: number
  ideationStatus?: IdeationStatus
  hasCurrentUserLiked: boolean
}

const FeaturedTopicView = ({ index, likes = 0, type, title, url, featuredImage, label, replyCount, views, fullWidth, post, customClass = '', addLikeHandler, ideationStatus, hasCurrentUserLiked }: Props) => (
  <article class={`featured-topic ${fullWidth ? 'featured-topic--full-width' : ''} ${featuredImage && 'featured-topic--featured-image'} ${customClass} ${type === TOPIC_TYPE_IDEA ? 'featured-topic--idea' : ''}`}>
    {type === TOPIC_TYPE_IDEA &&
      <button
        class={`featured-topic__vote ${hasCurrentUserLiked ? 'featured-topic__vote--voted' : ''}`}
        onClick={() => addLikeHandler(index)}
      >
        <span class='featured-topic__voteAmount'>{likes}</span>
        <Icon
          icon='triangle'
          width={10}
          height={8}
          customClass='featured-topic__voteIcon'
        />
      </button>}
    <a href={url} class='featured-topic__url-link' />
    <div className='featured-topic__url card-widget-wrapper'>
      <div>
        {label && type !== TOPIC_TYPE_IDEA &&
          <span className='topic__content-type-pill pill pill--uppercase pill--article qa-content-type-pill'>
            {label}
          </span>}
        {featuredImage &&
          <figure>
            <LazyLoader type='background' src={featuredImage} classNames='featured-topic__hero' alt={`Featured topic image ${index + 1}`} />
          </figure>}
      </div>
      <div className='featured-topic__title'>
        <h3
          className={`featured-topic__heading card-widget-title ${!featuredImage && label ? 'featured-topic__heading--no-image' : ''}`}
        >
          {title}
          {type === TOPIC_TYPE_IDEA && ideationStatus && (
            <span
              className='topic__content-type-pill pill pill--uppercase pill--idea qa-content-type-pill'
              style={`background-color: ${ideationStatus.bgColor}; color: ${ideationStatus.color};`}
            >
              {ideationStatus.name}
            </span>)}
        </h3>
        {((typeof window !== 'undefined' && window.inSidedData?.device !== 'mobile' && fullWidth) || !featuredImage) &&
          <p className='card-widget-text'>
            <ClampLines
              id='featured-topic-view' lines={3} text={htmlParser.stripHtml(post.content) || ''}
              buttons={false}
            />
          </p>}
        <div className='post-meta__container'>
          <div className='post-meta__container--left'>
            <UserAvatar user={post.author} extraClass='avatar avatar--XS' />
            <span className='thread-meta-item__date'>
              {post.relativeCreationDate}
            </span>
          </div>
          {type !== TOPIC_TYPE_IDEA &&
            <div className='post-meta__container--right'>
              <TopicViewsCount views={views} />
              <TopicReplyCount replyCount={replyCount} />
            </div>}
        </div>
      </div>
    </div>
  </article>
)

export default FeaturedTopicView
